import React, { FC, useCallback, useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import { useTranslation } from '../../services';

const TextToCopy: FC<{
	text: string;
	title: string;
	label?: string;
	hideText?: boolean;
	direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
}> = ({ text, title, label, direction = 'row', hideText = false }) => {
	const [copying, setCopying] = useState(false);
	const { t } = useTranslation();
	const copyText = useCallback(async () => {
		await navigator.clipboard.writeText(text || '');
		setCopying(true);
		setTimeout(() => {
			setCopying(false);
		}, 700);
	}, [text]);
	return (
		<>
			<Stack direction={direction}>
				<Stack direction="row" alignItems="center" sx={{ p: '5px' }} hidden={hideText}>
					{label && <span>{label}:&nbsp;</span>}
					<Box
						sx={{ cursor: 'pointer' }}
						component="b"
						onClick={copyText}
						title={title}
					>
						{text}
					</Box>
				</Stack>
				<Stack direction="row" alignItems="center">
					<Button
						onClick={copyText}
						color={copying ? 'success' : 'primary'}
						type="button"
						title={title}
					>
						{copying ? (
							<Stack direction="row" alignItems="center">
								<Box component="span" sx={{ p: '5px' }}>
									{t('copied')}
								</Box>
								<DoneIcon />
							</Stack>
						) : (
							<Stack direction="row" alignItems="center">
								<Box component="span" sx={{ p: '5px' }}>
									{title}
								</Box>
								<ContentCopyIcon />
							</Stack>
						)}
					</Button>
				</Stack>
			</Stack>
		</>
	);
};

export default TextToCopy;
